export default __webpack_public_path__ + "media/images/chart_16-c2f4ff939a6dd45f346274ab75e3fe20.png";